import { combineEpics } from 'redux-observable';
import * as steps from 'common/steps';
import * as introductionActions from './introductionActions';
import * as submissionActions from 'submission/submissionActions';
import { getCompleted } from 'common/stepReducerUtil';

import {
  createSyncLocalStorageEpic,
  createLoadLocalStorageEpic,
  createCompleteStepEpic,
  createAcknowledgeSubmissionEpic,
} from 'common/stepEpicUtil';

const syncLocalStorageEpic = createSyncLocalStorageEpic(
  [
    submissionActions.CANCEL_SUBMISSION,
    submissionActions.SUBMIT,
    introductionActions.COMPLETE_STEP,
  ],
  {
    completed: getCompleted,
  },
  introductionActions.localStorageSynced,
  steps.INTRODUCTION,
);

export default combineEpics(
  createLoadLocalStorageEpic(
    steps.INTRODUCTION,
    introductionActions.localStorageLoaded,
  ),
  syncLocalStorageEpic,
  createAcknowledgeSubmissionEpic(steps.INTRODUCTION),
  createCompleteStepEpic(introductionActions.COMPLETE_STEP, steps.INTRODUCTION),
);



// WEBPACK FOOTER //
// ./src/introduction/introductionEpic.js